import { heroTags } from "@/mocks/content";

interface HeroProps {
  onPickTag: (category: string) => void;
}

export default function Hero({ onPickTag }: HeroProps) {
  return (
    <section id="top" className="relative overflow-hidden scroll-mt-20">
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-background-100 via-background-50 to-background-50"></div>
      <div className="absolute -right-24 -top-24 -z-10 h-72 w-72 rounded-full bg-primary-100/70 blur-3xl"></div>
      <div className="absolute -left-20 top-40 -z-10 h-64 w-64 rounded-full bg-accent-100/60 blur-3xl"></div>

      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 px-6 pb-16 pt-28 md:px-8 md:pb-24 md:pt-32 lg:grid-cols-2 lg:gap-14">
        <div className="animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 font-label text-xs text-secondary-900">
            <i className="ri-heart-2-line"></i>
            恋爱技巧 · 情感咨询 · 两性话题
          </span>

          <h1 className="mt-5 font-heading text-3xl font-semibold leading-snug text-foreground-950 md:text-[2.7rem] md:leading-[1.28]">
            让每一次心动，
            <br />
            都能被好好回应
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">
            爱情岛是一个专注恋爱与情感的内容小站。这里汇集可落地的恋爱技巧、从约会前到约会后的完整攻略、值得认真讨论的两性话题，以及情感咨询建议、爱情故事与情感文章精选。无论你正在追求、热恋，还是感到困惑，都能在这里找到一点启发。
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <button
              type="button"
              onClick={() => document.getElementById("skills")?.scrollIntoView({ behavior: "smooth" })}
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-3 font-label text-sm text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-lightbulb-line text-base"></i>
              浏览恋爱技巧
            </button>
            <button
              type="button"
              onClick={() => document.getElementById("dating")?.scrollIntoView({ behavior: "smooth" })}
              className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-3 font-label text-sm text-foreground-800 whitespace-nowrap transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
            >
              <i className="ri-route-line text-base"></i>
              查看约会攻略
            </button>
          </div>

          <div className="mt-9">
            <p className="font-label text-xs tracking-wide text-foreground-500">热门话题 · 点击直达</p>
            <div className="mt-3 flex flex-wrap gap-2">
              {heroTags.map((tag) => (
                <button
                  key={tag}
                  type="button"
                  onClick={() => onPickTag(tag)}
                  className="rounded-full border border-background-300/80 bg-background-100 px-3.5 py-1.5 font-label text-xs text-foreground-700 transition-colors hover:border-accent-400 hover:bg-accent-100 hover:text-accent-900 cursor-pointer"
                >
                  {tag}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="animate-fade-in delay-2 relative">
          <div className="relative mx-auto w-full max-w-md overflow-hidden rounded-2xl border border-background-200 bg-background-100 lg:max-w-none">
            <div className="h-[360px] w-full sm:h-[440px] lg:h-[520px]">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20romantic%20editorial%20illustration%20of%20two%20people%20holding%20hands%20under%20soft%20golden%20sunset%20light%2C%20stylized%20painterly%20style%2C%20cream%20coral%20and%20amber%20color%20palette%2C%20blurred%20dreamy%20background%2C%20soft%20grain%20texture%2C%20tender%20intimate%20mood%2C%20minimal%20composition%20with%20generous%20negative%20space%2C%20high%20detail%2C%20harmonious%20warm%20tones&width=900&height=1100&seq=loveisland-hero-01&orientation=portrait"
                alt="暖色调插画里黄昏下牵手的一对恋人"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>

          <div className="absolute -bottom-5 left-4 right-4 mx-auto max-w-xs rounded-xl border border-background-200 bg-background-50/95 px-4 py-3 backdrop-blur sm:left-6 sm:right-auto">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                <i className="ri-quill-pen-line"></i>
              </span>
              <p className="text-xs leading-relaxed text-foreground-700">
                共 <strong className="text-foreground-950">6 大内容分区</strong>，从技巧到故事，一次读个够。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}